var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "_custom js-auth-modal",
      attrs: {
        name: _vm.name,
        scrollable: _vm.isScrollable,
        adaptive: true,
        width: _vm.width,
        height: _vm.height,
        "click-to-close": _vm.isClosableToOverlay
      },
      on: {
        "before-open": _vm.handlerBeforeOpen,
        "before-close": _vm.handlerBeforeClose,
        opened: _vm.handlerOpened,
        closed: _vm.handlerClosed
      }
    },
    [
      _c("div", { staticClass: "modal-desktop", class: _vm.rootClassModal }, [
        _vm.showHeader
          ? _c("div", { staticClass: "modal-desktop__header" }, [
              _vm.showBack
                ? _c(
                    "button",
                    {
                      staticClass: "modal-desktop__back",
                      attrs: { type: "button", "aria-label": "Назад" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.onBack($event)
                        }
                      }
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "modal-desktop__back-icon",
                          attrs: { width: 24, height: 24 }
                        },
                        [
                          _c("use", {
                            attrs: { "xlink:href": "#Arrow_back_24" }
                          })
                        ]
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showClose
                ? _c(
                    "button",
                    {
                      staticClass: "modal-desktop__close",
                      attrs: { type: "button", "aria-label": "Закрыть" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.onHide($event)
                        }
                      }
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "modal-desktop__close-icon",
                          attrs: { width: 24, height: 24 }
                        },
                        [_c("use", { attrs: { "xlink:href": "#Close_24" } })]
                      )
                    ]
                  )
                : _vm._e()
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "modal-desktop__container" },
          [_vm._t("default")],
          2
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }